<script>
  import { I18n } from "i18n-js"
  import i18n_translations from "../../../javascript/locales.json"

  let { RailsApp } = $props()

  const i18n = new I18n(i18n_translations)
  i18n.locale = RailsApp.I18n.locale

  import LinkToChatGPT from "../../layouts/_link_to_chatgpt.svelte"
</script>

<section id="personal-data" class="text-center pt-5 pb-5">
  <div class="container">
    <h2 class="text-black fw-normal mb-4">
      {i18n.t("Translations.Index.sections.personal_data.title")}
    </h2>
    <div class="description mb-5 m-auto">
      {i18n.t("Translations.Index.sections.personal_data.description")}
    </div>
    <div class="d-flex gap-2 justify-content-center">
      <div class="text-center align-self-center pe-3 pe-sm-5">
        <span class="d-block display-1 fw-bold">0</span>
        <span>{i18n.t("Translations.Index.sections.personal_data.zero_retention")}</span>
      </div>
      <div class="bg-black" style="width: 1px"></div>
      <div class="text-start ps-3 ps-sm-5">
        <strong class="d-block mb-3">{i18n.t("Translations.Index.sections.personal_data.data_collection.title")}</strong>
        <ul class="p-0 ps-3 m-0 d-flex flex-column gap-1 mx-auto">
          {#each i18n.t("Translations.Index.sections.personal_data.data_collection.list") as item, index}
            <li>
              {item}
              {#if index === 5}<LinkToChatGPT />{/if}
            </li>
          {/each}
        </ul>
      </div>
    </div>
  </div>
</section>
